import { render, staticRenderFns } from "./TableAulas.vue?vue&type=template&id=f289db40&scoped=true"
import script from "./TableAulas.vue?vue&type=script&lang=js"
export * from "./TableAulas.vue?vue&type=script&lang=js"
import style0 from "./TableAulas.vue?vue&type=style&index=0&id=f289db40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f289db40",
  null
  
)

export default component.exports